import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import Step from './Step'

export default function AddMembersPopupFormStep({
  setData,
  data,
  type,
  label,
}) {
  return (
    <div className={classes.wrapper}>
      <Step setData={setData} data={data} type={type} label={label} />
    </div>
  )
}

AddMembersPopupFormStep.propTypes = {
  setData: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  label: PropTypes.string,
  type: PropTypes.oneOf(['team', 'organization']),
}
